<template>
    <div>
        <div v-if="check_api_call_in_progress_show_backdrop" class="switch-comp-backdrop">
            <div v-if="check_api_call_in_progress" class="d-flex align-items-center justify-content-center w-100 h-100">
                <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448b" class="text-center w-100 d-flex justify-content-center"/>
            </div>
        </div>
        <switch-company-from-view-ticket-via-template v-if="show_switch_company" :company_details="company_details" @hideSwitchCompany="hideSwitchCompany" @hideSwitchCompanyAfterSwitchSuccess="hideSwitchCompanyAfterSwitchSuccess" modal_name="switch-company-ticket-details"></switch-company-from-view-ticket-via-template>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>

<script>
const SwitchCompanyFromViewTicketViaTemplate = () => import("./SwitchCompanyFromViewTicketViaTemplate.vue")
import navbarMixin from '../mixins/navbarMixin.js';
import { SweetModal } from 'sweet-modal-vue'
import global from '../global.js';
export default {
    props: [],
    mixins: [navbarMixin],
    data() {
        return{
            success_msg:'',
            warning_msg:'',
            show_switch_company: false,
            message: '',
            check_api_call_in_progress_show_backdrop:false,
            check_api_call_in_progress:false,
            company_details: null
        }
    },
    components: { 
        SwitchCompanyFromViewTicketViaTemplate,
        SweetModal 
    },
    methods: {
        hideSwitchCompany() {
            this.show_switch_company = false;
            setTimeout(() => {
                this.$modal.hide('switch-company-ticket-details');
                this.$router.replace({ name: "TicketsList" });
            }, 500);
        },
        hideSwitchCompanyAfterSwitchSuccess() {
            this.show_switch_company = false;
            setTimeout(() => {
                this.$modal.hide('switch-company-ticket-details');
            }, 500);
        },
        async checkIfCompanyExistsOrNot() {
            try {
                this.check_api_call_in_progress = true;
                this.check_api_call_in_progress_show_backdrop = true
                let params = {
                    "user_id": this.$route.params.user_id,
                    "company_id": this.$route.params.comp_id,
                    "product_name": "DigiHelp"  // ["DigiPOS", "DigiHelp", "Accounting", "SCM", "Cloud", "CRM", "DigiHRMS","DigiExpense"]
                };
                let response = await this.checkProductAccessWhileViewTicket(params);
                if(response.is_subscribed == true) {
                    this.check_api_call_in_progress = false;
                    this.company_details = response
                    this.show_switch_company = true;
                    setTimeout(() => {
                        this.$modal.show('switch-company-ticket-details');
                    }, 500);
                } else {
                    this.check_api_call_in_progress = false;
                    this.company_details = response
                    this.show_switch_company = true;
                    setTimeout(() => {
                        this.$modal.show('switch-company-ticket-details');
                    }, 500);
                    // console.log(response)
                    // if(response.response.has_organization == true) {
                    //     // this.warning_msg = `The helpdesk ticket is linked with ${response.response.company_name} of ${response.response.organization_name} and currently you are logged into ${this.loggedInUser.organization_name}`
                    // } else if(response.response.has_organization == false) {
                    //     // this.warning_msg = `The helpdesk ticket is linked with ${response.response.company_name} company and currently you are logged into ${this.loggedInUser.company_id}`
                    // } else {
                    //     // this.warning_msg = response.reason
                    // }
                    // this.$refs.warning_modal.open();
                    // setTimeout(() => {
                    //     this.$refs.warning_modal.close();
                    //     // this.check_api_call_in_progress = false;
                    //     // this.$router.replace({ name: "TicketsList" });
                    // }, 3000);
                }
            }
            catch(err) {
                console.log(err)
                this.warning_msg = err
                this.$refs.warning_modal.open();
                setTimeout(() => {
                    this.$refs.warning_modal.close();
                    this.check_api_call_in_progress = false;
                    this.$router.replace({ name: "TicketsList" });
                }, 3000);
            }
        }
    },
    mounted() {
        this.check_api_call_in_progress = true;
        this.check_api_call_in_progress_show_backdrop = true
        // if(this.$route.params.user_id == this.loggedInUser.user_id) {
            if(this.$route.params.comp_id == this.loggedInUser.company_id) {
                console.log("intoviewpage")
                this.$router.push({ path: "/ticketdetails/view/" + this.$route.params.id });
                this.check_api_call_in_progress = false;
                this.check_api_call_in_progress_show_backdrop = false
            } else {
                this.checkIfCompanyExistsOrNot()
            }
        // } else {
        //     this.warning_msg = "You are in a different Organization. Please Login to the associated Organization."
        //     this.$refs.warning_modal.open();
        //     setTimeout(() => {
        //         this.$refs.warning_modal.close();
        //         this.$router.replace({ path: "/ticketdetails/" + this.$route.params.id });
        //         this.check_api_call_in_progress = false;
        //         this.check_api_call_in_progress_show_backdrop = false
        //     }, 3000);
        // }
    },
    computed: {
        loggedInUser() {
            return this.$store.state.store.loggedInUser
        }
    },
}
</script>
<style scoped>
    .switch-comp-backdrop {
        position: fixed;
        width: 100%;
        z-index: 999;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0,0,0,0.5);
    }
</style>